<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="16" cy="16" r="16" fill="white" fill-opacity="0.2" />
  <path
    d="M15.9993 24.3334C20.6017 24.3334 24.3327 20.6025 24.3327 16.0001C24.3327 11.3977 20.6017 7.66675 15.9993 7.66675C11.397 7.66675 7.66602 11.3977 7.66602 16.0001C7.66602 20.6025 11.397 24.3334 15.9993 24.3334Z"
    stroke="#035462"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12.6667 8.5H13.5C11.875 13.3667 11.875 18.6333 13.5 23.5H12.6667"
    stroke="#035462"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M18.5 8.5C20.125 13.3667 20.125 18.6333 18.5 23.5"
    stroke="#035462"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.5 19.3333V18.5C13.3667 20.125 18.6333 20.125 23.5 18.5V19.3333"
    stroke="#035462"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.5 13.5002C13.3667 11.8752 18.6333 11.8752 23.5 13.5002"
    stroke="#035462"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
